const esLang = {
  title: 'Productos',
  'libre-venta': 'Productos de libre acceso',
  'prescripcion': 'Medicamentos de prescripción',
  'salud-animal': 'Salud animal',
  'nmDroga': 'Marca',
  'prncpioActvReg': 'Denominación genérica',
  'goUp': 'Volver Arriba',
  'visitWeb': 'Visitar sitio web',
  'buyBtn': 'Comprar',
  'selectProductTag': 'Selecciona el producto',
}
const enLang = {
  title: 'Productos',
  'libre-venta': 'Over-the-counter medications:',
  'prescripcion': 'Prescription drugs:',
  'salud-animal': 'Animal health:',
  'nmDroga': 'Marca',
  'prncpioActvReg': 'Denominación genérica',
  'goUp': 'Volver Arriba',
  'visitWeb': 'Visitar sitio web',
  'buyBtn': 'Comprar',
  'selectProductTag': 'Selecciona el producto',
}

export const langTexts = {
  es: esLang,
  en: enLang
}